import styled, { css } from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  type?: 'type1' | 'type2' | 'type3' | 'type4' | undefined;
  className?: string;
  children?: React.ReactNode;
  readonly onClick?: any;
}

export const Menu2LineBarItem = styled(Button)<IProps>`
  .img {
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.03);
    }
  }

  .text {
    ${mixin.ellipsis(1)};
    line-height: 130%;
  }

  ${props => {
    switch (props.type) {
      case 'type1':
        return css`
          height: 42px;
          border-radius: 40px;
          padding: 5px 16px 5px 5px;
          border: 1px solid rgba(0, 0, 0, 0.1);

          .img {
            flex: none;
            margin-right: 8px;
            border-radius: 32px;
            width: 32px;
            height: 32px;
          }

          .text {
            font-size: 14px;
            font-weight: 500;
            max-width: 181px;
            text-align: left;
          }

          &.active {
            background-color: #000;
            color: #fff;
          }
        `;
      case 'type2':
        return css`
          height: 33px;
          font-size: 14px;
          color: #777;
          border-radius: 33px;
          padding: 0 13px;
          border: 1px solid #e2e2e2;

          .text {
            max-width: 194px;
          }

          &.active {
            background-color: #000;
            border: 1px solid #000;
            color: #fff;
          }
        `;
      case 'type3':
        return css`
          height: 34px;
          font-size: 14px;
          color: #fff;
          font-weight: 500;
          border-radius: 100px;
          padding: 0 12px;
          background-color: #272727;

          .text {
            max-width: 194px;
          }

          &.active {
            background-color: #fff;
            color: #000;
            font-weight: 600;
          }
        `;
      case 'type4':
        return css`
          height: 32px;
          font-size: 14px;
          color: #777;
          border-radius: 100px;
          padding: 0 13px;
          background-color: #fff;
          border: 1px solid #eee;

          .text {
            max-width: 181px;
          }

          &.active {
            border: 1px solid #000;
            color: #000;
            font-weight: 600;
          }
        `;
      default:
        return null;
    }
  }}

  @media ${({ theme }) => theme.media.smMax} {
    ${props => {
      switch (props.type) {
        case 'type1':
          return css`
            height: ${mixin.pxToVw('42')};
            border-radius: ${mixin.pxToVw('40')};
            padding: ${mixin.pxToVw('5 16 5 5')};

            .img {
              margin-right: ${mixin.pxToVw('8')};
              border-radius: ${mixin.pxToVw('32')};
              width: ${mixin.pxToVw('32')};
              height: ${mixin.pxToVw('32')};
            }

            .text {
              font-size: ${mixin.pxToVw('14')};
              max-width: ${mixin.pxToVw('181')};
            }
          `;
        case 'type2':
          return css`
            height: ${mixin.pxToVw('33')};
            font-size: ${mixin.pxToVw('14')};
            border-radius: ${mixin.pxToVw('33')};
            padding: ${mixin.pxToVw('0 13')};

            .text {
              max-width: ${mixin.pxToVw('194')};
            }
          `;
        case 'type3':
          return css`
            height: ${mixin.pxToVw('34')};
            font-size: ${mixin.pxToVw('14')};
            border-radius: ${mixin.pxToVw('100')};
            padding: ${mixin.pxToVw('0 12')};

            .text {
              max-width: ${mixin.pxToVw('194')};
            }
          `;
        case 'type4':
          return css`
            height: ${mixin.pxToVw('32')};
            font-size: ${mixin.pxToVw('14')};
            border-radius: ${mixin.pxToVw('100')};

            padding: ${mixin.pxToVw('0 13')};

            .text {
              max-width: ${mixin.pxToVw('181')};
            }
          `;
        default:
          return null;
      }
    }}
  }

  @media ${({ theme }) => theme.media.pc} {
    ${props => {
      switch (props.type) {
        case 'type1':
          return css`
            height: 48px;
            padding: 6px 18px 6px 6px;

            .img {
              margin-right: 9px;
              border-radius: 36px;
              width: 36px;
              height: 36px;
            }

            .text {
              font-size: 16px;
              max-width: 207px;
              font-weight: 600;
            }
          `;
        case 'type2':
          return css`
            height: 46px;
            font-size: 17px;
            border-radius: 46px;
            padding: 0 22px;

            .text {
              max-width: 221px;
            }
          `;
        case 'type3':
          return css`
            height: 41px;
            font-size: 16px;
            font-weight: 600;
            border-radius: 30px;
            padding: 0 24px;

            .text {
              max-width: 221px;
            }
          `;
        case 'type4':
          return css`
            height: 46px;
            font-size: 17px;
            border-radius: 100px;
            padding: 0 22px;
            background-color: #f6f6f6;
            border: 0;

            .text {
              max-width: 221px;
              font-weight: 500;
              color: #555;
            }

            &.active {
              background-color: #fff;
              border: 2px solid #000;
            }
          `;
        default:
          return null;
      }
    }}
  }
`;
